import { Fragment } from "react";
import {
  InputLabel,
  Props,
  SliderDiscreteWrap,
  clampAndSnap,
} from "./SliderDiscrete.Parts";
import { DiscreteInput } from "./discrete-input/DiscreteInput";

export const SliderDiscrete = ({
  labels,
  value,
  disabled,
  setValue,
  step = 1,
  min = 0,
  max = 100,
  onKeyDown,
}: Props) => {
  const InputWrap = labels?.length ? "label" : Fragment;
  const expectedLength = Math.max(
    String(Math.ceil(min) + step).length,
    String(Math.floor(max) - step).length,
  );

  return (
    <SliderDiscreteWrap>
      {value?.flatMap((v, i) => [
        <InputWrap key={i}>
          {(labels?.[i] && (
            <InputLabel variant="xsmall">{labels?.[i]}</InputLabel>
          )) ||
            null}
          <DiscreteInput
            disabled={disabled}
            step={step}
            min={min}
            max={max}
            expectedLength={expectedLength}
            value={v}
            onKeyDown={onKeyDown}
            normalize={clampAndSnap({ min, max, step })}
            setValue={(value) => {
              setValue?.((prev) => {
                const next = [...(Array.isArray(prev) ? prev : [prev])];
                next[i] = value;
                return next;
              }, new Event("change"));
            }}
          />
        </InputWrap>,
      ]) || null}
    </SliderDiscreteWrap>
  );
};
